import {WagmiAdapter} from '@reown/appkit-adapter-wagmi';
import {
  mainnet,
  polygon,
  base,
  bsc,
  arbitrum,
  tron,
  solana,
  bitcoin,
} from '@reown/appkit/networks';
import {createConfig, http} from '@wagmi/vue';
import {injected, walletConnect} from '@wagmi/vue/connectors';

export const projectId = '2b422a27978e2194ad3e1ee48b47bc7d';
if (!projectId) {
  throw new Error('VITE_PROJECT_ID is not set');
}

export const networks = [
  mainnet,
  polygon,
  bsc,
  tron,
  solana,
  bitcoin,
  arbitrum,
  base];

export const wagmiAdapter = new WagmiAdapter({
  networks,
  projectId,
});

export const config = createConfig({
  chains: networks,
  connectors: [
    injected(),
    walletConnect({projectId: projectId}),
  ],
  transports: {
    [mainnet.id]: http(),
    [polygon.id]: http(),
    [bsc.id]: http(),
    [tron.id]: http(),
    [solana.id]: http(),
    [bitcoin.id]: http(),
    [arbitrum.id]: http(),
    [base.id]: http(),
  },
  autoConnect: false,
});